/* ================= MODAL ROOT ================= */

.quizModalContainer :global(.ant-modal-container) {
  border-radius: 16px;
  overflow: hidden;
  padding: 20px 0;
}

/* ================= HEADER ================= */

.headerLayer {
  height: 40px;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  display: flex;
  padding: 0 24px;
}

.headerProgress {
  margin-top: 22px;
  height: 3px;
  position: relative;
  background: #d6d6d6;
}

.optionIconImage {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

/* ================= PROGRESS ================= */

.progressBar {
  background-color: #04051b;
  height: 3px;
}

/* ================= HEADER FLOATING ================= */

.backButton {
  width: 40px;
  height: 40px;
  background: #f6f6f6;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.backButton:hover {
  cursor: pointer;
}

.progressCounter {
  background: #f6f6f6;
  padding: 4px 10px;
  font-size: 12px;
  border-radius: 999px;
  border: 1px solid #f0f0f0;
}

/* ================= CONTENT ================= */

.quizModalContent {
  padding: 0 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
}

.title {
  font-size: 28px;
  line-height: 42px;
  font-weight: 600;
  color: #04051b;
  margin-top: 28px;
}

.question {
  font-size: 16px;
  color: #525252;
}

/* ================= OPTIONS ================= */

.optionsColumn {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.optionRow {
  height: 56px;
  padding: 8px 16px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fafafa;
  cursor: pointer;
  position: relative;
}

.optionIcon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.optionText {
  font-size: 16px;
  font-weight: 500;
}

.selected {
  background: #fef5e7;
  border: 1px solid #ffba42;
}

/* ================= CHECK ================= */

.checkMark {
  position: absolute;
  right: 0;
  top: 0;
  width: 36px;
  height: 28px;
  background: #ffa100;
  color: #fff;
  border-top-right-radius: 10px;
  border-bottom-left-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ================= BUTTON ================= */

.nextButton {
  margin-top: auto;
  height: 56px;
  border-radius: 12px;
  background: #e5e5e5;
  color: #737373;
}

.nextButton:enabled {
  background: #ffa100 !important;
  color: #04051b !important;
}

/* ================= MOBILE FULLSCREEN ================= */

@media (max-width: 480px) {
  .quizModalContainer {
    top: 0 !important;
    bottom: 0 !important;
    padding-bottom: env(safe-area-inset-bottom);
  }

  .quizModalContainer :global(.ant-modal-content) {
    height: 100vh;
    border-radius: 0;
  }

  .quizModalContainer :global(.ant-modal-body) {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .headerLayer {
    padding: 0 16px;
  }

  .progressBar {
    margin: 0 16px;
  }

  .quizModalContent {
    padding: 0 16px 16px;
  }

  .nextButton {
    margin-bottom: env(safe-area-inset-bottom);
  }
}

.myClassname {
  background-color: red;
}
